/**
 * IMPORTS
 */
import {FlagsmithClientProvider} from '@openfeature/flagsmith-client-provider';
import {OpenFeature} from '@openfeature/web-sdk';
import React from 'react';
import Metadata from 'src/config/Metadata';
import Routes from 'src/config/routes';
import {createLogger} from 'src/logger';
import {logger} from 'src/logger';

import 'antd/dist/antd.css';
import 'draft-js/dist/Draft.css';
import 'src/components/style.scss';

/**
 * CODE
 */

// load config before app
Metadata.load().then(() =>
{
    // initialize logger
    createLogger(Metadata.config.logger);

    // set open feature provider
    OpenFeature.setProvider(new FlagsmithClientProvider({
        api: Metadata.config.flags.url,
        cacheFlags: true,
        cacheOptions: {
            storageKey: '@pecazap:flags',
        },
        environmentID: Metadata.config.flags.key,
        onError: (error) =>
        {
            // log flagsmith error
            logger?.error('CVJPZ0097E', {error: error.message});
        },
    }));

    // set logger
    OpenFeature.setLogger({
        error: (args) =>
        {
            logger?.error('CVJPZ0097E', {error: String(args)});
        },
        debug: () => null,
        info: () => null,
        warn: () => null,
    });
})

/**
 * I render the App component.
 *
 * :returns: App component
 */
function App ()
{
    // return App component
    return (
        <Routes />
    );
}


/**
 * EXPORTS
 */
export default App;
